import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { tickColor, gridColor, baseFont, AGENT_COLORS } from './chartConstants';

const AgentBarChart = ({ ticketsPerAgent }) => {
    const chartData = useMemo(() => {
        if (!Array.isArray(ticketsPerAgent) || ticketsPerAgent.length === 0) return null;
        return {
            labels: ticketsPerAgent.map(a => a.agent_name),
            datasets: [{
                label: 'Tickets Handled',
                data:  ticketsPerAgent.map(a => a.tickets_count),
                backgroundColor:      ticketsPerAgent.map((_, i) => AGENT_COLORS[i % AGENT_COLORS.length]),
                hoverBackgroundColor: ticketsPerAgent.map((_, i) => AGENT_COLORS[i % AGENT_COLORS.length].replace('0.85', '1')),
                borderWidth: 0,
            }],
        };
    }, [ticketsPerAgent]);

    const options = {
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: {
            mode: 'index', intersect: false,
            backgroundColor: '#1F2937',
            titleFontFamily: baseFont, titleFontSize: 12, titleFontStyle: 'bold',
            bodyFontFamily: baseFont,  bodyFontSize: 12,
            xPadding: 10, yPadding: 10,
            callbacks: { label: (item) => ` ${item.yLabel} ticket${item.yLabel !== 1 ? 's' : ''}` },
        },
        scales: {
            xAxes: [{ gridLines: { display: false }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, maxRotation: 30, autoSkip: false } }],
            yAxes: [{ gridLines: { color: gridColor }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, beginAtZero: true, callback: (v) => Number.isInteger(v) ? v : null } }],
        },
    };

    if (!chartData) return <div style={{ color: tickColor, padding: 20 }}>No agent assignment data available</div>;
    return <div style={{ height: '100%', minHeight: 160 }}><Bar data={chartData} options={options} /></div>;
};

export default AgentBarChart;
